import Cookies from 'js-cookie'
import { getLanguage } from '@/lang/index'

const state = {
  sidebar: {
    opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
    withoutAnimation: false,
    menu: {
      menuList: JSON.parse(localStorage.getItem('sidebar'))?.menu?.menuList || [],
      menuLink: JSON.parse(localStorage.getItem('sidebar'))?.menu?.menuLink || '',
      menuId: null
    }
  },
  route: {
    // name: null,
    // params: null,
    // path: null,
    // fullPath: null,
    // query: null
  },
  device: 'desktop',
  size: Cookies.get('size') || 'medium',
  language: getLanguage()
}

const getters = {
  getSidebarMenuList(state) {
    return state.sidebar.menu.menuList
  },
  getSidebarMenuLink(state) {
    return state.sidebar.menu.menuLink
  },
  getRouteData(state) {
    return state.route
  }
}

const mutations = {
  TOGGLE_SIDEBAR: state => {
    state.sidebar.opened = !state.sidebar.opened
    state.sidebar.withoutAnimation = false
    if (state.sidebar.opened) {
      Cookies.set('sidebarStatus', 1)
    } else {
      Cookies.set('sidebarStatus', 0)
    }
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    Cookies.set('sidebarStatus', 0)
    state.sidebar.opened = false
    state.sidebar.withoutAnimation = withoutAnimation
  },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device
  },
  SET_SIZE: (state, size) => {
    state.size = size
    Cookies.set('size', size)
  },
  SET_LANGUAGE: (state, language) => {
    state.language = language
    Cookies.set('language', language)
  },
  SET_SIDEBAR_MENU_LIST: (state, data) => {
    state.sidebar.menu.menuList = data
  },
  SET_SIDEBAR_MENU_LINK: (state, link) => {
    state.sidebar.menu.menuLink = link
  },
  SET_ROUTE_DATA: (state, data) => {
    state.route = data
  }
}

const actions = {
  toggleSideBar({ commit }) {
    commit('TOGGLE_SIDEBAR')
  },
  closeSideBar({ commit }, { withoutAnimation }) {
    commit('CLOSE_SIDEBAR', withoutAnimation)
  },
  toggleDevice({ commit }, device) {
    commit('TOGGLE_DEVICE', device)
  },
  setLanguage({ commit }, language) {
    commit('SET_LANGUAGE', language)
  },
  setSize({ commit }, size) {
    commit('SET_SIZE', size)
  },
  setSidebarMenuList({ commit }, menu) {
    commit('SET_SIDEBAR_MENU_LIST', menu)
  },
  setSidebarMenuLink({ commit }, link) {
    commit('SET_SIDEBAR_MENU_LINK', link)
  },
  setRouteData({ commit }, routeData) {
    commit('SET_ROUTE_DATA', routeData)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
